var map = {
	"./about-partners": 14681,
	"./about-partners.json": 14681,
	"./concentrate": 34634,
	"./concentrate.json": 34634,
	"./menu": 95033,
	"./menu-update": 97637,
	"./menu-update.json": 97637,
	"./menu.json": 95033,
	"./product-paralax": 38803,
	"./product-paralax.json": 38803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34545;